import { Badge } from "@/components/ui/Badge";
import type { KnowledgeEntry } from "../types";

const SCOPE_LABEL: Record<string, string> = {
  global: "Globalny",
  branch: "Branża",
  investor: "Inwestor",
  division: "Oddział",
  subdivision: "Pododdział/Rejon",
  project: "Projekt",
};

type BadgeColor = "gray" | "blue" | "green" | "red" | "yellow" | "purple" | "orange" | "black";

const SCOPE_COLOR: Record<string, BadgeColor> = {
  global: "gray",
  branch: "blue",
  investor: "purple",
  division: "green",
  subdivision: "yellow",
  project: "orange",
};

const BRANCH_LABEL: Record<string, string> = {
  telecom: "Telekomunikacja",
  energy: "Energetyka",
};

/** Poziom wpisu z doprecyzowaniem (branża / inwestor / oddział / rejon / projekt). */
export function ScopeBadge({ entry }: { entry: KnowledgeEntry }) {
  let detail = "";
  if (entry.scope === "branch") detail = BRANCH_LABEL[entry.branch] ?? entry.branch;
  if (entry.scope === "investor") detail = entry.investor_name ?? "";
  if (entry.scope === "division") detail = entry.client_branch_name ?? "";
  if (entry.scope === "subdivision") detail = entry.client_sub_branch_name ?? "";
  if (entry.scope === "project") detail = entry.project_name ?? "";
  return (
    <Badge color={SCOPE_COLOR[entry.scope] ?? "gray"}>
      {SCOPE_LABEL[entry.scope]}
      {detail ? `: ${detail}` : ""}
    </Badge>
  );
}
